module.exports = __webpack_public_path__ + "static/media/toilet.6a1a32d5.svg";